module.exports = __webpack_public_path__ + "static/img/thumbnail.2d77c53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/1911262/thumbnail.jpg
// module id = koSv
// module chunks = 1